// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // DB_HOST=localhost
  // DB_PORT=3306
  // DB_DATABASE=bquicr2b_bakery
  // DB_USERNAME=bquicr2b_bakery
  // DB_PASSWORD=@user$321FJKERP

  // php_api_server: 'http://10.0.0.8:8100'
    // php_api_server: 'http://127.0.0.1:8000'
   php_api_server: '' 
  //  php_api_server: 'https://bquickerp.com/backend'
  //  php_api_server: 'http://localhost/erp/fujishka_erp'
  // php_api_server: 'http://192.168.1.5:8000'
  // php_api_server: 'http://tpbridge.com/backend1'
  //  php_api_server: 'http://tpbridge.com/fujishka/backend'

  //  php_api_server: 'https://alhazmicloud.com/backend'
  // php_api_server: 'https://bquickerp.net/backend'
  // php_api_server: 'https://bquickerp.in/backend'
  // php_api_server: 'https://phpv.fujishkaerp.com//backend'
  // php_api_server: 'https://fujishkaerp.com/backend'
  //  php_api_server: 'https://fujishkaerp.net/backend'
    // php_api_server: 'https://fujishkaerp.in/backend'
  //  php_api_server: 'https://erp.fujishkaerp.com/backend'
  //  php_api_server: 'https://fujishkacloud.com/backend'
    // php_api_server: 'https://fujishkacloud.in/backend'
  //  php_api_server: 'https://gcc.fujishkaerp.com/backend'
  //  php_api_server: 'https://test.bquickerp.in/backend'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack framecoms such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
